import { FC, useEffect, useState, ReactNode } from "react";
import { createPortal } from "react-dom";

export interface IDynamicPortal {
  id?: string;
  className?: string;
  children?: ReactNode;
}

const DynamicPortal: FC<IDynamicPortal> = ({
  id = "",
  className,
  children,
}) => {
  const [el, setEl] = useState<HTMLElement>(null);

  useEffect(() => {
    let dynamic;
    let curEl = el;
    if (!el) {
      curEl = document.getElementById(id) || document.createElement("div");
      dynamic = !curEl.parentElement;

      if (dynamic) {
        curEl.id = id;
        document.body.appendChild(curEl);
      }

      if (className) {
        curEl.classList.add(className);
      }

      setEl(curEl);
    }

    return () => {
      if (dynamic && curEl.parentElement) {
        curEl.parentElement.removeChild(curEl);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, className]);

  return el ? createPortal(children, el) : null;
};
export default DynamicPortal;
